import React, { useEffect, useState } from 'react'
import Journey from '../../journeys/journey/Journey'
import { TemplateProps } from '../../journeys/journey/Interfaces';
import Header from '../../organisms/Header/Header';
import './BolLayout.scss'
import { Spinner } from 'ams-ui-reactkit';
import { navigate, useLocation } from '@reach/router';
import { StoreContext } from '../../context';
import { useContextSelector } from '@fluentui/react-context-selector';
import { actionTypeConstants } from '../../utils';
import bol from '../../journeys/journey/bol.json';

const customerDetail = {
    "CustomerName": "test lead",
    "MoveDate": "07/20/2023",
    "Address": "  STRATFORD, CT, 06615",
    "Contact": "469-251-2670",
    "ValuationMultiPlier": "0.6",
    "CustomerEmail": "venkatesh@in.allmysons.com",
    "IsSigned": 1,
    "options": 4,
    "FVPOption": 3,
    "CustomerSelected": 15000,
    "CoverageCost": 250,
    "OfficePhone": "203-388-0094",
    "SignedDated": "07/19/2023  8:14 AM",
    "BranchID": 40,
    "BranchPhone": "203-388-0094",
    "BranchEmail": "Connecticut@allmysons.com",
    "DeductibleAmount": 300,
    "IsDeductible": true,
    "Signatureurl": [
        {
            "putUrl": "https://bol-application-dev.s3.amazonaws.com/signatures/7056225/FVP?AWSAccessKeyId=ASIA437WX7QEJBGOOZXO&Expires=1689777531&Signature=oxdnfFx7LSjJtUb5Yt990Q7JrU8%3D&X-Amzn-Trace-Id=Root%3D1-64b7e76b-60c9d0811a0cd11e79c5fe88%3BParent%3D3c57a13bcb46335a%3BSampled%3D1%3BLineage%3D23fef4cc%3A0&x-amz-security-token=IQoJb3JpZ2luX2VjEAYaCXVzLWVhc3QtMSJHMEUCIQCx%2FsqAJu0M6%2FLAi1hmpPvec6ZXX7G7JXERUIjPsbIs1AIgJUaQt34r%2BEcwaAw8wjsvYhdwVq9EawhGomWHWVm17mgqkQMIj%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAEGgw4ODQ3NDM4NjMzMDQiDEqWuc2fe0Bh5umC%2FyrlAuCJMCahYW8kchZGJdh1tH6P6P1fN%2F%2BDDSDecDlJUixntHwBb9tQhwmP4m90AFAHfFsblQOrsBIPA13696h%2FLT2aMTP7XIY1PvbK6oRNQ5vwHFyfj8T5dRSBBqvBHCNbVm0HOJhWEAgxPOdL%2BirjXoZas%2FVBCYavB4rTyKWWf0rdj9k2tDnQ9VLMtiYOi5kavztbdWHOjdTrgm8QQM0HuOIN8tuVtNBmcf6dVeyozgO7MU4xECFvIbznTMCNk550CFHhy%2FKlMZu6Zv6dVD%2FiFcl6Ltvih3kSn1gTxFrKETBJ0EC%2BckdtNuXJdbZRF1kbVIXpQzGyv9GuinEmWf3p9fTYmNCxcSL9Uwv5wFSFak1TUVNdGi2D4DxwiThThnHxWFuhmaXaEJsdTxCQXMYg7S0%2Fgc5Lr9IMBZ0JyeQpme1%2Bzvax5pFUrF5tP2%2FprY5VLLIKeIC7uE4gVFKwmfmx4joJvlpHKDC8zd%2BlBjqeAazGGzkw8Y%2BS8reVDnaU7REdJpzAf1bhSG6ufMjczip9UvhhSwI%2Bd4bxJZ1UfoW0oTE6xTretb37aWekSf%2BBjqdYInUHlRTNZ09Z%2B1AJtEvSY49SHvU7KzOU88kGa4ybaFX0Em1FzSa1w7tElVifqAXhXl7tSCvEbpeDxnoCNVncCD0MMxWwDGlsVG3QcmL9RCXU2v9iID3NLi1btkg8",
            "getUrl": "https://bol-application-dev.s3.amazonaws.com/signatures/7056225/FVP?AWSAccessKeyId=ASIA437WX7QEJBGOOZXO&Expires=1689777531&Signature=rXXOz66R5mzS3ruMgi062r8HS5A%3D&X-Amzn-Trace-Id=Root%3D1-64b7e76b-60c9d0811a0cd11e79c5fe88%3BParent%3D3c57a13bcb46335a%3BSampled%3D1%3BLineage%3D23fef4cc%3A0&x-amz-security-token=IQoJb3JpZ2luX2VjEAYaCXVzLWVhc3QtMSJHMEUCIQCx%2FsqAJu0M6%2FLAi1hmpPvec6ZXX7G7JXERUIjPsbIs1AIgJUaQt34r%2BEcwaAw8wjsvYhdwVq9EawhGomWHWVm17mgqkQMIj%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARAEGgw4ODQ3NDM4NjMzMDQiDEqWuc2fe0Bh5umC%2FyrlAuCJMCahYW8kchZGJdh1tH6P6P1fN%2F%2BDDSDecDlJUixntHwBb9tQhwmP4m90AFAHfFsblQOrsBIPA13696h%2FLT2aMTP7XIY1PvbK6oRNQ5vwHFyfj8T5dRSBBqvBHCNbVm0HOJhWEAgxPOdL%2BirjXoZas%2FVBCYavB4rTyKWWf0rdj9k2tDnQ9VLMtiYOi5kavztbdWHOjdTrgm8QQM0HuOIN8tuVtNBmcf6dVeyozgO7MU4xECFvIbznTMCNk550CFHhy%2FKlMZu6Zv6dVD%2FiFcl6Ltvih3kSn1gTxFrKETBJ0EC%2BckdtNuXJdbZRF1kbVIXpQzGyv9GuinEmWf3p9fTYmNCxcSL9Uwv5wFSFak1TUVNdGi2D4DxwiThThnHxWFuhmaXaEJsdTxCQXMYg7S0%2Fgc5Lr9IMBZ0JyeQpme1%2Bzvax5pFUrF5tP2%2FprY5VLLIKeIC7uE4gVFKwmfmx4joJvlpHKDC8zd%2BlBjqeAazGGzkw8Y%2BS8reVDnaU7REdJpzAf1bhSG6ufMjczip9UvhhSwI%2Bd4bxJZ1UfoW0oTE6xTretb37aWekSf%2BBjqdYInUHlRTNZ09Z%2B1AJtEvSY49SHvU7KzOU88kGa4ybaFX0Em1FzSa1w7tElVifqAXhXl7tSCvEbpeDxnoCNVncCD0MMxWwDGlsVG3QcmL9RCXU2v9iID3NLi1btkg8"
        }
    ],
}
const isLocalJourney = false;
const BolLayout: React.FC<TemplateProps> = (props: any) => {
    const location = useLocation();
    const params = new URLSearchParams(window.location.search);
    const uiState: any = useContextSelector(StoreContext, store => store?.appState?.ui);
    const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);
    const customerInfoState: any = useContextSelector(StoreContext, store => store?.appState?.customerInfo);
    const { templateProps } = props;
    const [loading, setLoading] = useState(false);

    const getCustomerDetail = async (CID: any) => {
        try {
            setLoading(true);
            const endPoint = `${process.env.REACT_APP_API_ENDPOINT}/getCustomerDetails`;
            await fetch(endPoint, {
                method: 'POST',
                headers: {
                    'x-api-key': `${process.env.REACT_APP_FVP_API_KEY_DEV}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "CustomerId": CID,
                    "source":  parseInt(params.get('source' )|| "0" )
                })
            })
                .then(response => response.json())
                .then((data) => {
                    localStorage.setItem("customerInfo", JSON.stringify(data));
                    const source: any = params.get('source') || "0";

                    dispatch({
                        'type': actionTypeConstants.UPDATE_CUSTOMER_INFO,
                        'payload': {
                            ...data, "customerId": localStorage.getItem('CID'),
                            "isLocalJourney": isLocalJourney,
                            "IsTab": source,
                        }
                    })
                    setLoading(false);

                    const isAllow = isAllowToChange(new Date(data?.MoveDate));

                    if (source == "1" || source == "2" || source == "3") {
                        navigate("finalize")
                    }
                    else if ((source == "0" && data?.IsSigned == 1) || isAllow == false) {
                        console.log("navigte to thank-you-all-set:source:", source, ", IsSigned:", data?.IsSigned == 1, ",isAllow:", isAllow)
                        navigate("thank-you-all-set");
                        //navigate("thank-you")
                        //navigate("finalize")
                    } else {
                        navigate("finalize")
                    }
                }).catch((error)=>{
                    console.error('ERROR:', error);
                    setLoading(false);
                });
        } catch (error) {
            console.error('ERROR:', error);
            setLoading(false);
        }
    }

    useEffect(() => {
        var CID: any = params.get('CustomerId') || "7059000";//"7054218";//"7054279";
        const source: any = params.get('source') || "0";
        if (!CID) {
            CID = localStorage.getItem("CID")
        }
        else {
            localStorage.setItem("CID", CID)
        }
        console.log("CID:", CID);
        if (!isLocalJourney) {
            getCustomerDetail(CID);
        } else {
            dispatch({
                'type': actionTypeConstants.UPDATE_CUSTOMER_INFO,
                'payload': { ...customerDetail, "customerId": localStorage.getItem('CID'), "FvpJourney": bol, "isLocalJourney": isLocalJourney, "IsTab": source }
            })
            navigate("finalize")
            //navigate("thank-you-all-set");
        }
    }, [])

    // useEffect(() => {
    //     if (customerInfoState) {
    //         const source: any = params.get('source') || "0";
    //         const isAllow = isAllowToChange(new Date(customerInfoState?.MoveDate));

    //         if ((source == "0" && customerInfoState?.IsSigned == 1) || isAllow == false) {
    //             console.log("navigte to thank-you-all-set")
    //             navigate("thank-you-all-set")
    //             return;
    //         }
    //     }
    //     navigate("finalize")
    // }, [customerInfoState])
    const isAllowToChange = (moveDate: Date) => {
        //let moveDate = new Date(2023, 5, 18);
        const prevDate = getPreviousDay(moveDate);
        const cDate = new Date();
        console.log("moveDate:", moveDate);
        console.log("prevDate:", prevDate);
        console.log("cDate:", cDate, prevDate.getHours())

        console.log("compare:", cDate < moveDate)
        if (prevDate.toDateString() === cDate.toDateString()) {
            console.log("equal:", prevDate.getHours());
            if (prevDate.getHours() >= 19) {
                console.log("DONT ALLOW AS >=7");
                return false
            } else {
                console.log("ALLOW");
                return true;
            }
        } else {
            console.log("Previous date and current date is not equal");
            if (cDate < moveDate) {
                console.log("ALLOW");
                return true;
            } else {
                console.log("DONT ALLOW");
                return false
            }
        }
    }
    const getPreviousDay = (date: Date) => {
        var dateObj = new Date();
        dateObj.setDate(date.getDate() - 1);
        return dateObj;
    }

    const isBackNav = () => {
        if (uiState?.showBackLink === "hide") {
            return false;
        }
        if (uiState?.showBackLink === "show") {
            return true;
        }
        return false;
    };

    return (
        <div className='full-block'>
            {
                loading || !customerInfoState?.FvpJourney ?
                    <div className='flex-center h-100vh'>
                        <Spinner />
                    </div>
                    :
                    <>
                      <Header backNav={isBackNav()} progressValue={0}  logoSrc = {customerInfoState?.FvpJourney?.logo}/>
                      <div className="outlineContainer111">
                        {/* <SnackMessage /> */}
                        <Journey goal={customerInfoState?.FvpJourney?.goal || {}} pages={customerInfoState?.FvpJourney?.pages || {}} />
                    </div>
                    </>

                // loading || !journeytemplate ?
                //     <div className='flex-center h-100vh'>
                //         <Spinner />
                //     </div>
                //     :
                //     <div className="outlineContainer">
                //         <SnackMessage />
                //         <Journey goal={journeytemplate?.goal || {}} pages={journeytemplate?.pages || {}} />
                //     </div>
            }
        </div>
    )
}


export default BolLayout